import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createAction } from '@reduxjs/toolkit';
import { ANALYTICS_ACTION_TYPES, ANALYTICS_ICON_TYPES, ANALYTICS_ITEM_TYPES, ANALYTICS_OBJECT_TYPES, CALLBACK_REQUEST_BUTTON_NAME, PHONE_FIELD_NAME, POPUP_TITLE } from '@fttb/common';
import { getActionBarButton, getActionBarTitle } from "./selectors";
import { sendActionBarClickOnPhoneYm, sendActionBarClickYm, sendParamsWithField } from "./analytics";
import { isPageTypeFmc } from "../blocks/selectors";
import { selectCommonAnalyticsData } from "../analytics/selectors";
export var openBackCall = createAction('OPEN_BACK_CALL');
export var onActionBarClickAnalytics = function onActionBarClickAnalytics() {
  return function (dispatch, getState) {
    var state = getState();
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    dispatch(openBackCall(false));
    sendParamsWithField(_objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
      action: ANALYTICS_ACTION_TYPES.click,
      item_type: ANALYTICS_ITEM_TYPES.icon,
      icon_type: ANALYTICS_ICON_TYPES.back,
      object_type: ANALYTICS_OBJECT_TYPES.popup,
      popup_title: POPUP_TITLE
    }));
  };
};
export var handlePhoneClick = function handlePhoneClick() {
  return function (_, getState) {
    var state = getState();
    var isConvergent = isPageTypeFmc(state);
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    var link_text = getActionBarTitle(state);
    sendActionBarClickOnPhoneYm({
      isConvergent: isConvergent,
      data: _objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
        link_text: link_text,
        action: ANALYTICS_ACTION_TYPES.click,
        item_type: ANALYTICS_ITEM_TYPES.link,
        object_type: ANALYTICS_OBJECT_TYPES.floating
      })
    });
  };
};
export var handleClickWithAnalytics = function handleClickWithAnalytics() {
  return function (dispatch, getState) {
    var state = getState();
    var button_text = getActionBarButton(state).text;
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    var isConvergent = isPageTypeFmc(state);
    sendActionBarClickYm(isConvergent);
    sendParamsWithField(_objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
      button_text: button_text,
      action: ANALYTICS_ACTION_TYPES.click,
      item_type: ANALYTICS_ITEM_TYPES.button,
      object_type: ANALYTICS_OBJECT_TYPES.floating
    }));
    dispatch(openBackCall(false));
  };
};
export var handleFocusInput = function handleFocusInput() {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    sendParamsWithField(_objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
      action: ANALYTICS_ACTION_TYPES.click,
      item_type: ANALYTICS_ITEM_TYPES.field,
      field_name: PHONE_FIELD_NAME,
      object_type: ANALYTICS_OBJECT_TYPES.popup,
      popup_title: POPUP_TITLE
    }));
  };
};
export var handleFillPhoneInput = function handleFillPhoneInput() {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    sendParamsWithField(_objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
      action: ANALYTICS_ACTION_TYPES.fill_in,
      item_type: ANALYTICS_ITEM_TYPES.field,
      field_name: PHONE_FIELD_NAME,
      object_type: ANALYTICS_OBJECT_TYPES.popup,
      popup_title: POPUP_TITLE
    }));
  };
};
export var handleSubmitCallbackRequest = function handleSubmitCallbackRequest() {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    sendParamsWithField(_objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
      action: ANALYTICS_ACTION_TYPES.click,
      item_type: ANALYTICS_ITEM_TYPES.button,
      button_name: CALLBACK_REQUEST_BUTTON_NAME,
      object_type: ANALYTICS_OBJECT_TYPES.popup,
      popup_title: POPUP_TITLE
    }));
  };
};